import React from 'react';

import SingpassLoginButtonImg from './singpass-login-btn.svg';

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

export const SingpassLoginButtonImage = (props: ImageProps) => (
  <img {...props} src={SingpassLoginButtonImg} alt="Login with Singpass" />
);
